import { LeadsPlan, LeadsState, Plans, Steps, getInitialLeadsState } from './../../../models/LeadsState';
import { MutationTree } from 'vuex';
import { leadsConstants } from '@puls/puls-common-constants';

export const LeadsMutations = {
	SET_LEADS_PLANS: 'SET_LEADS_PLANS',
	RESET_LEADS_STATE: 'CLEAR_LEADS_PLANS',
	TOGGLE_SELECTED_PLAN: 'TOGGLE_SELECTED_PLAN',
	SET_STEP: 'SET_STEP',
	SET_CUSTOM_LEADS_AMOUNT: 'SET_CUSTOM_LEADS_AMOUNT',
	SET_CUSTOM_PLAN: 'SET_CUSTOM_PLAN'
}

export const mutations: MutationTree<any> = {
	[LeadsMutations.SET_LEADS_PLANS] (state: LeadsState, payload: Plans) {	
		state.uuid = Math.random().toString().split('.')[1] + "_uuid";
		state.leadsPlans = payload;
	},
	[LeadsMutations.RESET_LEADS_STATE] (state: LeadsState) {
		const newState = getInitialLeadsState();
		state.leadsPlans = newState.leadsPlans;
		state.selectedPlanId = newState.selectedPlanId;
		state.step = newState.step;
		state.uuid = newState.uuid;
	},
	[LeadsMutations.TOGGLE_SELECTED_PLAN] (state: LeadsState, payload: number) {
		const isCustomPlan = payload === leadsConstants.CUSTOM_PACK_PLAN_ID;
		const prevSelection = state.selectedPlanId;

		if (isCustomPlan) { 
			state.leadsPlans[leadsConstants.CUSTOM_PACK_PLAN_ID].price = 0;
			state.leadsPlans[leadsConstants.CUSTOM_PACK_PLAN_ID].leads_amount = 0;
		}

		state.selectedPlanId = prevSelection === payload ? 0 : payload;
	},
	[LeadsMutations.SET_STEP] (state: LeadsState, step: Steps) {
		state.step = step;
	},
	[LeadsMutations.SET_CUSTOM_LEADS_AMOUNT] (state: LeadsState, payload: number) {
		state.leadsPlans[leadsConstants.CUSTOM_PACK_PLAN_ID].leads_amount = payload;
		state.leadsPlans[leadsConstants.CUSTOM_PACK_PLAN_ID].price = 0;
	},
	[LeadsMutations.SET_CUSTOM_PLAN] (state: LeadsState, { price = 0, leads_amount = 0 }: Partial<LeadsPlan>) {
		state.leadsPlans[leadsConstants.CUSTOM_PACK_PLAN_ID].price = price;
		state.leadsPlans[leadsConstants.CUSTOM_PACK_PLAN_ID].title = leads_amount ? `${leads_amount} Verified Jobs Package` : '';
	}
}
